module.exports = __webpack_public_path__ + "img/ta_bg.37eb659d.jpg";